// extracted by mini-css-extract-plugin
module.exports = {"tab":"__8cNprbhO","info":"XCWzJqah","text":"KomaKhI0","filter":"yTGWV3D9","button":"kC7ZLFlF"};